import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { SharedService } from '../../../shared/services/shared.service';
import { InvestmentPropertyModel } from './investment-property.model';
import { InvestmentPropertyService } from './investment-property.service';
import { InvestmentPropertyFormComponent } from './investment-property-form.component';


@Component({
    selector: 'convfact-dialog-import-account-investment-property',
    templateUrl: './investmentProperty-dialog-importAccount.component.html',
    styleUrls: ['./investment-property.component.css'],
    standalone: false
})
export class InvestmentPropertyDialogImportAccount {

    dataImport: InvestmentPropertyModel = this.data.dataImport;

    constructor(
        public dialogRef: MatDialogRef<InvestmentPropertyFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public investmentPropertyService: InvestmentPropertyService,
        public sharedService: SharedService
    ) { }

    startImport() {
        this.sharedService.importAccountsUpdate(this.dataImport, "Property").then(result => {
            this.dialogRef.close(); 
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }




}
